const BookList=(payload)=>{
    return {type:'BookList',payload}
}

export {BookList}